export const ALLOWED_SKIP_BAG_WASTE_TYPES = [
  "tiles",
  "garden waste",
  "general waste",
  "cardboard",
  "wood",
  "not listed",
] as const;

export const DISALLOWED_SKIP_BAG_WASTE_TYPES = [
  "brick",
  "plasterboard",
  "rubble",
  "soil",
] as const;

export const ALL_SKIP_BAG_WASTE_TYPES = [
  ...DISALLOWED_SKIP_BAG_WASTE_TYPES,
  ...ALLOWED_SKIP_BAG_WASTE_TYPES,
] as const;
